/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { PromptControllerGetTaskStatusQueryResponse, PromptControllerGetTaskStatusPathParams, PromptControllerGetTaskStatus400, PromptControllerGetTaskStatus401, PromptControllerGetTaskStatus404, PromptControllerGetTaskStatus409, PromptControllerGetTaskStatus500 } from "../types/PromptControllerGetTaskStatus.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getPromptControllerGetTaskStatusUrl(promptRewardID: PromptControllerGetTaskStatusPathParams["promptRewardID"]) {
  const res = { method: 'GET', url: `/api/prompt/${promptRewardID}/status` as const }
  return res
}

/**
 * {@link /api/prompt/:promptRewardID/status}
 */
export async function promptControllerGetTaskStatus(promptRewardID: PromptControllerGetTaskStatusPathParams["promptRewardID"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PromptControllerGetTaskStatusQueryResponse, ResponseErrorConfig<PromptControllerGetTaskStatus400 | PromptControllerGetTaskStatus401 | PromptControllerGetTaskStatus404 | PromptControllerGetTaskStatus409 | PromptControllerGetTaskStatus500>, unknown>({ method : "GET", url : getPromptControllerGetTaskStatusUrl(promptRewardID).url.toString(), ... requestConfig })
  return res.data
}